/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { ImageURL } from "../../../../Environment/Environment";
import defaultImg from "../../../../assets/img/thumbnail.png";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { toastEmmit } from "../../../../Helper/Toastr";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";
import {
  showSuccessAlert,
  showErrorAlert,
  showDeleteConfirmation,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";

export default function Product() {
  const [productlist, setProductList] = useState();
  const [state, setstate] = useState("");
  const [Title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [normalImage, setnormalImage] = useState("");
  const [localnormalImage, setLocalNormalImage] = useState("");
  const [status, setstatus] = useState("");
  const [selectedState, setselectedState] = useState("");
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [price, setprice] = useState();
  useEffect(() => {
    getproductList();
  }, [search_key, currentPage]);

  const getproductList = () => {
    setLoading(true);
    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_PRODUCT_LIST, param).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          setProductList(res.data.data.rows);
          SetTotalPageCount(res.data.totalPages);
          SetTotalCount(res.data.totalItems);
          setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    console.log(selectedState);
    settitle(selectedState?.product_title);
    setdescription(selectedState?.description);
    setstatus(selectedState?.status);
    setprice(selectedState?.price);
    setnormalImage(
      selectedState?.product_image ? selectedState?.product_image : ""
    );
    setLocalNormalImage(
      selectedState?.product_image ? selectedState?.product_image : defaultImg
    );
  }, [selectedState]);

  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setnormalImage(e.target.files[0]);
      setLocalNormalImage(window.URL.createObjectURL(e.target.files[0]));
    }
  };

  function resetModal() {
    setError("");
    settitle("");
    setdescription("");
    setnormalImage("");
    setprice("")
    setLocalNormalImage(defaultImg);
    setsubmitLoader(false);
  }

  const addproduct = (e) => {
    e.preventDefault();

    if (!Title || !description || !normalImage) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    const formData = new FormData();
    if (state !== "Add") {
      formData.append("id", selectedState?.id);
    }
    formData.append("product_title", Title);
    formData.append("description", description);
    formData.append("product_image", normalImage);
    formData.append("price", price);
    formData.append("type", 0);
    formData.append("gallery_id", 0);
    formData.append("status", 'Active');
    const apiURL =
      state === "Add" ? API_URL.ADD_PRODUCT : API_URL.UPDATE_PRODUCT;

    PostFormData(apiURL, formData).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getproductList);
          resetModal();
          document.getElementById("closeEditModal").click();
          // getproductList();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
    id: id,
      status: status === "Active" ? "Inactive" : "Active",
    };
    const formdata= new FormData()
    formdata.append('id', id)
    formdata.append('status', status === "Active" ? "Inactive" : "Active",)

    PostFormData(API_URL.UPDATE_PRODUCT, formdata).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(`Status ${status === "Active" ? "inactive" : "active"} successfully`, getproductList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  function Delete(id, name) {
    const data = {
      product_id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_PRODUCT, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getproductList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Products List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Products List </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="align-items-center d-flex justify-content-between row">
                    {/* <div className="col-md-4 p-0">
                      <div className="offset-md-1">
                        <button
                          type="submit"
                          className="btn btn-primary py-2"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={() => {
                            setstate("Add");
                            resetModal();
                          }}
                        >
                          Add Product
                        </button>
                      </div>
                    </div> */}
                    <div className="col-md-4 p-0 offset-8">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Title"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div>
                    <div>
                      <div className="table-responsive mt-4">
                        {!loading && (
                          <table className="table table-hover table-bordered table-striped">
                            <thead>
                              <tr>
                                <th className="text-center">S.No</th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Title</th>
                                <th className="text-center">Description</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {productlist &&
                                productlist?.map((item, i) => (
                                  <tr key={i}>
                                    <td className="text-center">
                                      {i + S_No_Count + 1}
                                    </td>
                                    <td className="text-center">
                                      <img
                                        src={item?.product_image}
                                        alt="..."
                                        onError={(e) => {
                                          e.target.src = defaultImg;
                                        }}
                                      />
                                    </td>
                                    <td className="text-center">
                                      {item?.product_title
                                        ? item?.product_title
                                        : "N/A"}
                                    </td>
                                    <td className="text-center" style={{whiteSpace:'break-spaces', lineHeight:'1.2'}}>
                                      {item?.description
                                        ? item?.description
                                        : "N/A"}
                                    </td>

                                    <td className="text-center">
                                      <label
                                        className={
                                          item?.status === "Active"
                                            ? "badge badge-success"
                                            : "badge badge-danger"
                                        }
                                      >
                                        {" "}
                                        {item?.status}
                                      </label>
                                    </td>
                                    <td className="text-center">
                                      <span className="toggle-switch">
                                        <Switch
                                          checked={item?.status === "Active"}
                                          onChange={() => {
                                            changeStatus(
                                              item.id,
                                              item.status
                                            );
                                          }}
                                          size="small"
                                          color="primary" // You can customize the color
                                          inputProps={{
                                            "aria-label": "toggle switch",
                                          }}
                                        />
                                      </span>
                                      <span
                                        title="Edit"
                                        style={{ cursor: "pointer" }}
                                        className="mx-2"
                                        data-toggle="modal"
                                        data-target="#EditModal"
                                        onClick={() => {
                                          setstate("Edit");
                                          setselectedState(item);
                                        }}
                                      >
                                        <i className="text-dark fas fa-pen"></i>{" "}
                                      </span>
                                      {/* <span
                                      title="view"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2 text-warning"
                                      data-toggle="modal"
                                      data-target="#viewModal"
                                    >
                                      <i className="fas fa-eye"></i>{" "}
                                    </span> */}
                                      <span
                                        title="Delete"
                                        style={{ cursor: "pointer" }}
                                        className="mx-2"
                                        onClick={() => {
                                          Delete(item?.id, "Product");
                                        }}
                                      >
                                        <i className="text-danger fas fa-trash"></i>{" "}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              {productlist && productlist.length === 0 && (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    <h6 className="p-3"> No Data Found </h6>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                        {loading ? (
                          <div className="LoaderSpinner">
                            <MoonLoader
                              color={"#003bff"}
                              loading={loading}
                              speedMultiplier={0.6}
                              size={50}
                            />
                            <div>Loading... Please wait.</div>
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="mt-4">
                          <Pagination
                            counting={S_No_Count}
                            totaldata={TotalCount}
                            pagecount={TotalPageCount}
                            onChangePage={handlePageClick}
                            activePage={currentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- add edit modal -----------*/}
      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Product
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetModal}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="form-group col-12">
                    <label>Title</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Title"
                      value={Title}
                      onChange={(e) => settitle(e?.target.value)}
                      readOnly={selectedState?.id}
                    />
                    {error && !Title && (
                      <div className="error mt-1">Title is required</div>
                    )}
                  </div>
                  <div className="form-group col-12">
                    <label>Starting Price ( $ )</label>
                    <input
                      type="number"
                      name="price"
                      className="form-control"
                      placeholder="price"
                      value={price}
                      onChange={(e) => setprice(e?.target.value)}
                    />
                    {error && !price && (
                      <div className="error mt-1">price is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-12">
                    <label>Description </label>
                    <textarea
                      className="form-control"
                      placeholder="Description "
                      cols="1"
                      rows="3"
                      value={description}
                      onChange={(e) => setdescription(e?.target.value)}
                    ></textarea>
                    {error && !description && (
                      <div className="error mt-1">Description is required</div>
                    )}
                  </div>
                </div>
                <div className="mt-3">
                  {/* <label>Select Image</label> */}

                  <div className="row d-flex align-items-start">
                    <div className="col-md-5">
                      <div>
                        <div className="p-0">
                          <div>
                            <span className="btn btn-primary">
                              Select Image
                              <span>
                                <input
                                  type="file"
                                  name="image"
                                  accept=".jpg,.jpeg,.png"
                                  className="btn-input position-absolute"
                                  style={{ opacity: 0 }}
                                  onChange={(e) => onimageUpload(e)}
                                />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7 col-12 mt-2">
                      <img
                        src={localnormalImage}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                      {error && !normalImage && (
                        <div className="error text-center mt-1">
                         Image is required
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetModal}
                >
                  Close
                </button>

                <button
                  className="btn btn-primary py-2"
                  onClick={(e) => addproduct(e)}
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
